import { logger } from "./logger"
import { TokenStorage } from "./token-storage"

export const tokenStorage = new TokenStorage(logger)
